import React, { createContext, useContext } from "react";

const defaultContext = {
  copilotOpen: false,
  setCopilotOpen: () => {},
  isCopilotAvailable: false,
  hasCxGptAccess: false,
  cxGptAccessLoading: true,
  advisorPlan: null,
  advisorPlanName: null,
  advisorIsPro: false,
  advisorTrial: null,
};

const CopilotShellContext = createContext(defaultContext);

export const useCopilotShell = () => useContext(CopilotShellContext);

export const CopilotShellProvider = ({
  children,
  copilotOpen,
  setCopilotOpen,
  hasCxGptAccess = false,
  cxGptAccessLoading = false,
  advisorPlan = null,
  advisorPlanName = null,
  advisorIsPro = false,
  advisorTrial = null,
}) => (
  <CopilotShellContext.Provider
    value={{
      copilotOpen,
      setCopilotOpen,
      isCopilotAvailable: !cxGptAccessLoading,
      hasCxGptAccess: hasCxGptAccess === true,
      cxGptAccessLoading: !!cxGptAccessLoading,
      advisorPlan,
      advisorPlanName,
      advisorIsPro: advisorIsPro === true,
      advisorTrial,
    }}
  >
    {children}
  </CopilotShellContext.Provider>
);
